export const WGLL_BASE_URL = 'https://revup.mindtickle.com/internal-pages/wgll';

export const WGLL_DEFAULT_PATHS = {
  LIBRARY: 'library.html',
  ORG_READINESS: 'org_readiness.html',
} as const;

export type WgllConfigKey = keyof typeof WGLL_DEFAULT_PATHS;
